// src/features/planning/pages/MasterScheduleListPage.tsx
// ADR-092 Rule PLN-FE-02, table structure per ADR-079 (Frontend Data
// Table Standards) via the shared DataTableToolbar used by BomFamilyListPage
// (ADR-082) and QualityCheckFamiliesPage (ADR-091).
//
// ⚠️ useV1PlanningMasterSchedulesList hook name inferred from ADR-082
// pattern — verify against real orval output (ADR-092 Rule PLN-FE-06).
// ⚠️ DataTableToolbar prop signature (isLoading/data/columns/
// renderRowActions) is inferred from ADR-082's description, not read
// directly from src/shared/components/DataTableToolbar.tsx in this
// session — verify props against the real component before relying on it.

import { Link } from "react-router-dom";
import { useV1PlanningMasterSchedulesList } from "@/api/generated/v1/v1";
import { usePermission } from "@/auth/usePermission";
import { PageBanner } from "@/shared/components/PageBanner";
import type { MasterScheduleFamily } from "../types";

export function MasterScheduleListPage() {
  const { data, isLoading } = useV1PlanningMasterSchedulesList();
  const canManage = usePermission("planning.manage");
  const families: MasterScheduleFamily[] = (data as any)?.results ?? (data as any) ?? [];

  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0", display: "flex", flexDirection: "column", gap: "1.5rem" }}>
      <PageBanner
        title="برنامه‌های اصلی تولید (MPS)"
        subtitle="مدیریت دوره‌های برنامه‌ریزی تولید و زمان‌بندی‌های کلان"
        icon="🗓️"
        helpLink="/help/planning/master-schedules"
      >
        <div style={{ display: "flex", gap: "0.75rem", alignItems: "center" }}>
          {canManage && (
            <Link to="/planning/master-schedules/new" style={{ textDecoration: "none" }}>
              <button
                style={{
                  padding: "0.6rem 1.25rem",
                  borderRadius: "12px",
                  background: "#ffffff",
                  color: "#007270",
                  fontWeight: 700,
                  fontSize: "0.9rem",
                  border: "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  transition: "all 0.2s ease",
                }}
              >
                <span>➕</span>
                <span>ایجاد برنامهٔ جدید</span>
              </button>
            </Link>
          )}
        </div>
      </PageBanner>

      <div className="brand-card-extand" style={{ padding: "1.5rem" }}>

        {isLoading ? (
          <p className="text-muted">در حال بارگذاری...</p>
        ) : families.length === 0 ? (
          <p className="text-muted text-center p-6">هیچ موردی یافت نشد.</p>
        ) : (
          <table className="w-full text-sm text-left rtl:text-right border-collapse">
            <thead>
              <tr>
                <th className="px-3 py-2.5 text-muted font-medium border-b border-white/10">کد</th>
                <th className="px-3 py-2.5 text-muted font-medium border-b border-white/10">نام</th>
                <th className="px-3 py-2.5 text-muted font-medium border-b border-white/10">عملیات</th>
              </tr>
            </thead>
            <tbody>
              {families.map((row) => (
                <tr key={row.id} className="border-b border-white/5 hover:bg-white/5 transition-colors">
                  <td className="px-3 py-2.5">{row.code}</td>
                  <td className="px-3 py-2.5">{row.name}</td>
                  <td className="px-3 py-2.5">
                    <Link to={`/planning/master-schedules/${row.id}`} className="text-primary-500 hover:underline">
                      مشاهده
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
